<template>
    <transition name="Assets" appear>
        <div class="Assets">
            <div ref="container" class="Assets__container">
                <div ref="items" class="Assets__subdivision">
                    <Item 
                        v-for="(asset, i) in subs" 
                        :categorie="categorie" 
                        :asset="asset" 
                        :key="subs[i]" 
                        :enable="last == asset" 
                        :small="colors != 0" />
                </div>
                <ColorPicker v-if="colors != 0"/>
                <Nav v-if="categorie !='empty' && slugIsIn(['defi3'])"/>
            </div>
        </div>
    </transition>
</template>
<script>

import { Categories } from '../js/Categories.js'
import ColorPicker from './ColorPicker'
import Nav from './Nav'
import Item from './Item'

export default {
    name: 'Assets',
    components: { ColorPicker, Nav, Item },
    data: ()=>({
        ready: false,
        slide: 1,
        division: 0,
        assets: [],
        subs: [],
        last: null,
        colors: 0
    }),
    computed: { 
        categorie() { return this.$store.getters['app/categorie'] },
        history() { return this.$store.getters['app/history'] },
    },
    watch: {
        'categorie': {
            immediate: true,
            deep: true,
            handler() {    

                this.slide = 1
                this.assets = []
                this.division = 0
                this.subs = []
                this.last = null
                this.colors  = 0

                this.$nextTick(()=>{
                    const obj = _.find(Categories, { 'id': this.categorie })
                    if(obj) {
                        _.each(obj.items, (i)=>{ this.assets.push(i) })
                        this.division = obj.division
                        this.colors = obj.colors.length
                        this.updateDivision()
                    }
                    this.$store.commit('app/SET_COLOR', null)

                    if(this.$tween)
                        this.$tween.kill()

                    this.$tween = new TimelineMax()
                        .set(this.$refs.container, { opacity: 0 })
                        .to(this.$refs.container, .5, { opacity: 1, delay: .5 })
                })
            }
        },
        slide(nw, od) {
            this.updateDivision()
            if(this.$slide)
                this.$slide.kill()
            this.$slide = new TimelineMax()
                        .set(this.$refs.items, { opacity: 0 })
                        .to(this.$refs.items, .5, { opacity: 1, delay: .5 })
        },
        history(nw, od) {
            if(nw.length > 0)
                this.last = _.last(nw)['value']
        },

        // o_ADAD_HANNAH: ['clothing_10', 'beachball'],
        // o_ANNIE_BAILLARGEON: ['balloons', 'confetti', 'paintsplatter'],
        // o_CLAUDIE_GAGNON: ['butterflies', 'crown', 'flowers', 'hat', 'spoon'],
        // o_HUA_JIN: ['clothing_08', 'flower'],
        // o_JJ_LEVINE: ['glasses_02', 'facialhair_03', 'clothing_01', 'clothing_02'],
        // o_JONAS_ST_MICHAEL: ['clothing_13', 'bird'],
        // o_PATRICK_BERNATCHEZ: ['clothing_12', 'helmet', 'horse'],
        // o_SKAWENNATI: ['hair_07', 'clothing_11'],
        // o_MARISA_PORTOLESE: ['cat', 'necklace'],
        // o_MORIDJA_KITENGE_BANZA: ['clothing_03', 'tie']

    },
    methods: {
        onClick(asset) {
            this.$store.commit('app/SET_AMBIANCE', 'selection')
            this.$store.commit('app/SET_PORTRAIT', { categorie: this.categorie, value: asset })
        },
        updateDivision() {
            let dpt = ((this.slide-1)*this.division) 
            if(dpt == -1) dpt = 0
            let end = ((dpt+this.division) >= this.assets.length) ? this.assets.length : (dpt+this.division)
            this.subs = this.assets.slice(dpt, end)
        },
    },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Assets
    position absolute
    top 50%
    transform translate(0, -50%) 
    width 758px
    height 659px
    background-size cover
    background-position top center
    background-image url("../img/assets/interface.png")
    display flex 
    justify-content flex-end
    align-items center
    padding-right 48px 
    transition opacity .5s, transform .5s
    transition-delay .25s

    &-enter
        transform translate(-100%, -50%)
        opacity 0

    &-leave-active
        transition-delay 0s
        transform translate(-100%, -50%)
        opacity 0

    &__container
        width 528px
        height 490px
        position relative

    &__subdivision
        display flex 
        flex-direction row
        flex-wrap wrap
        padding 12px 0 0 24px

    &__item 
        cursor pointer
        width 155px
        height 206px    
        margin 0px 8px 8px 0
        border 2px solid transparent
        background rgba(255, 255, 255, .1)

        & img 
            width 100%

        &.small
            height 155px

        &.enable 
           border 2px solid white 
       
</style>































































// WEBPACK FOOTER //
// src/components/defis/components/Assets.vue